import { FunctionComponent } from "react";

interface BulletPointParagraphProps {
  title: string;
  text: string;
}

const BulletPointParagraph: FunctionComponent<BulletPointParagraphProps> = ({
  title,
  text,
}: BulletPointParagraphProps) => {
  return (
    <div className="w-auto md:w-1/3 px-5 text-left">
      <p className="text-2xl font-semibold py-4">{title}</p>
      <p className="font-normal text-zinc-500 text-lg leading-6">{text}</p>
    </div>
  );
};

export default BulletPointParagraph;
